import React from 'react';
import { DocumentationLayoutGrid, SidebarGridItem, ContentGridItem } from './DocumentationLayoutGrid';
import { Navigation } from '../navigation';
import { SiteTitle } from './SiteTitle';
import { PoweredByConfluenza } from './PoweredByConfluenza';
import { FixedNavigation } from './FixedNavigation';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var DocumentationLayoutWide = function DocumentationLayoutWide(_ref) {
  var children = _ref.children,
      location = _ref.location,
      data = _ref.data,
      onStateChanged = _ref.onStateChanged,
      deltas = _ref.deltas,
      rhythm = _ref.rhythm;
  var title = data.site.siteMetadata.title,
      confluenzaConfig = data.config.nodes,
      docs = data.navigation.docs;
  return _jsxs(DocumentationLayoutGrid, {
    rhythm: rhythm,
    children: [_jsx(SidebarGridItem, {
      children: _jsxs(FixedNavigation, {
        rhythm: rhythm,
        children: [_jsx(SiteTitle, {
          title: title
        }), _jsx(Navigation, {
          docs: docs,
          location: location,
          confluenzaConfig: confluenzaConfig,
          onStateChanged: onStateChanged,
          deltas: deltas
        }), _jsx(PoweredByConfluenza, {})]
      })
    }), _jsx(ContentGridItem, {
      children: children
    })]
  });
};

export { DocumentationLayoutWide };